
import {globalData} from "../common/config"
export const getLangData=function(pcode="default"){
  const langZH={
    enterpriseinformation:{//企业信息
      groupCertificateInfo:"证件信息",
      groupName:"企业名称",
      cityInfo:"投保地址",
      groupAddressDetail:"企业详细地址："
    },
    policyholder:{

    },
    insuredperson:{

    },
    insuredate:{

    },
    staffinfo:{

    },
    express:{

    },
    declare:{

    }
  }
  const langEN={
    enterpriseinformation:{//企业信息
      groupCertificateInfo:"证件信息gg",
      groupName:"企业名称",
      cityInfo:"投保地址",
      groupAddressDetail:"企业详细地址："
    }
  }
  if(pcode=="P060028"){
    globalData["langData"]=langEN;
  }else{
    globalData["langData"]=langZH;
  }
  //console.log(globalData["langData"])
}
